module.exports = "/_next/static/images/icon-192-176fed321067a858ae5016988ee12220.png";